import React, { useContext } from "react";
import { IntlContext } from "context";
import { SubCategory } from "types/subCategory";
import { Sparkles } from "lucide-react";
import { getListingDetailLabelKeys, type ListingCategoryDetail, type ListingDetailKind } from "./types";

interface Props {
    detail: ListingCategoryDetail;
    kind: ListingDetailKind;
}

const HouseKeeping: React.FC<Props> = ({ detail, kind }) => {
    const intl = useContext(IntlContext);
    const { subcategory, data } = detail;
    const labels = getListingDetailLabelKeys(kind);

    if (subcategory !== SubCategory.CLEANING) {
        return null;
    }

    return (
        <>
            {labels.equipment && <label>{intl.formatMessage(labels.equipment)}</label>}
            <Sparkles size={16} aria-hidden="true" />
            <span>
                {Number(data.bring_products) === 1
                    ? intl.formatMessage(labels.bringYes)
                    : intl.formatMessage(labels.bringNo)}
            </span>
        </>
    );
};

export default HouseKeeping;
